import { render, staticRenderFns } from "./TeachersExecution.vue?vue&type=template&id=70b0dc0e&"
import script from "./TeachersExecution.vue?vue&type=script&lang=js&"
export * from "./TeachersExecution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports